import * as React from 'react';
import { Card } from 'antd';
import { CardProps } from 'antd/lib/card';
import './index.less';

interface NiCardProps extends CardProps {
  titleExtra?: React.ReactNode;
  hoverExtra?: boolean;
}
interface NiCardState { }

export class NiCard extends React.Component<NiCardProps, NiCardState> {

  render() {
    const props = {
      ...this.props
    };

    if (props.titleExtra) {
      props.title = <span className="title-span">
        {props.title}
        {<div className="title-extra">{props.titleExtra}</div>}
      </span>;
    }

    if (this.props.hoverExtra) {
      props.extra = <div className="hover-extra-container">{this.props.extra}</div>;
      delete props.hoverExtra;
    }

    delete props.titleExtra;

    return (
      <Card
        {...props}
        className={`ni-card ${!props.children && 'no-content'} ${props.className}`}
      >
      </ Card >
    );
  }
}
